import { computed } from 'vue';

import useCurrentUserRole from '@/features/authentication/current-user/useCurrentUserRole';
import AccessibleFeature from '@/features/users/feature-accessibility/models/AccessibleFeature';
import useHasAccessToFeature from '@/features/users/feature-accessibility/useHasAccessToFeature';
import { UserRole } from '@/features/users/models/users';

const ROLES_WHICH_HAS_ACCESS_TO_FACEBOOK = new Set([UserRole.SUPER_ADMIN]);

export default function useIsCurrentUserCanViewFacebook() {
  const currentUserRole = useCurrentUserRole();

  const hasAccessToFacebookFeature = useHasAccessToFeature(AccessibleFeature.FACEBOOK_ACCOUNTS);

  return computed(
    () =>
      (currentUserRole.value != null && ROLES_WHICH_HAS_ACCESS_TO_FACEBOOK.has(currentUserRole.value))
      || hasAccessToFacebookFeature.value,
  );
}
